module.exports = __webpack_public_path__ + "static/media/home-01.e7f262ed.jpg";